import { WritableAtom, atom } from 'nanostores';
import { AppointmentDetails } from '../../types/consultation';
import { getAppointmentData } from '../../general/utils/consultation/appointment-service';

export interface BookedAppointment {
  email?: string;
  phone_number?: string;
  appointmentId?: string;
  appointment?: AppointmentDetails | Promise<AppointmentDetails>;
  consent_confirmed?: boolean;
}

export default function createBookedAppointmentStore() {
  const bookedAppointmentStore: WritableAtom<BookedAppointment | undefined> = atom();
  function update(bookedAppointment?: Omit<BookedAppointment, 'appointment'> & { appointment?: AppointmentDetails }) {
    const newBookedAppointment = { ...bookedAppointmentStore.get(), ...bookedAppointment };

    if (!newBookedAppointment.email && !newBookedAppointment.phone_number) {
      return;
    }

    //if appointment info is already send with the update we asume it is up to date
    if (!bookedAppointment?.appointment && newBookedAppointment.appointmentId) {
      newBookedAppointment.appointment = getAppointmentData(newBookedAppointment.appointmentId);
    }

    bookedAppointmentStore.set(newBookedAppointment as BookedAppointment);
  }
  return {
    store: bookedAppointmentStore,
    update
  };
}

export type BookedAppointmentStore = ReturnType<typeof createBookedAppointmentStore>;
